import { DataRoomShareableLink } from 'models/ShareableLink';
import {
  ASCENDING_DESCENDING_COPY,
  EARLIEST_LATEST_COPY,
  LOWEST_HIGHEST_COPY,
  SortingDirectionValues,
} from 'models/Sort';

export type ShareableTable = Pick<
  DataRoomShareableLink,
  | 'name'
  | 'accessNumber'
  | 'fileIds'
  | 'lastAccessDate'
  | 'createdAt'
  | 'linkAccess'
  | 'linkExpiresDate'
  | 'totalAccessCount'
>;

export type ShareableTableKeys = Array<keyof ShareableTable>;

export const TABLE_COLUMNS: ShareableTableKeys = [
  'name',
  'accessNumber',
  'totalAccessCount',
  'fileIds',
  'lastAccessDate',
  'createdAt',
  'linkExpiresDate',
  'linkAccess',
];

export const HEADING_TRANSLATIONS: Record<
  typeof TABLE_COLUMNS[number],
  string
> = {
  name: 'a-z',
  accessNumber: 'access',
  totalAccessCount: 'visitsUC',
  fileIds: 'files',
  lastAccessDate: 'lastAccess',
  createdAt: 'created',
  linkExpiresDate: 'expiresOn',
  linkAccess: '',
};

export const CUSTOM_COL_SIZES: Partial<
  Record<typeof TABLE_COLUMNS[number], number>
> = {
  name: 300,
  accessNumber: 360,
  lastAccessDate: 160,
  totalAccessCount: 80,
  createdAt: 120,
  linkExpiresDate: 120,
  fileIds: 80,
  linkAccess: 100,
};

export const SORTING_VALUES: Partial<
  Record<typeof TABLE_COLUMNS[number], string>
> = {
  name: 'sortName',
  accessNumber: 'linkAccess',
  totalAccessCount: 'totalAccessCount',
  fileIds: 'filesCount',
  lastAccessDate: 'lastAccessDate',
  createdAt: 'createdAt',
  linkExpiresDate: 'linkExpiresDate',
};

export const SL_SORT_DIRECTION_COPY: SortingDirectionValues = {
  sortName: ASCENDING_DESCENDING_COPY,
  linkAccess: LOWEST_HIGHEST_COPY,
  accessNumber: LOWEST_HIGHEST_COPY,
  fileIds: LOWEST_HIGHEST_COPY,
  lastAccessDate: EARLIEST_LATEST_COPY,
  createdAt: EARLIEST_LATEST_COPY,
  linkExpiresDate: EARLIEST_LATEST_COPY,
};
